import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import { navbarToggler } from "../../redux/actions/utilities";
import { useDispatch } from "react-redux";
// collapse parametresi title altında gruplanan inputların gösterilip gösterilmemesi için kullanılmıştır.
// title'a tıklandığında açılan kapanan bir collapsable grouptur.
// is active sayfa refreshlerinde group içindeki herhangi bir url aktifse aktif gelmelidir.
export default function SideMenuItemGroup(props) {
  let { label, children, icon, isActive, ...args } = props;
  const [collapse, setCollapse] = useState(false);
  const isGroupShown = () => {
    return collapse || isActive;
  };

  return (
    <div className={`km__c--side-menu-item-group-container`} {...args}>
      <div
        className={`km__c--side-menu-item-group-title ${
          isActive ? "km__c--side-menu-item-group-title-is-active" : ""
        }`}
        onClick={() => setCollapse(!collapse)}
        id={`sm-main-${icon}`}
      >
        <span className="km__c--side-menu-icon">
          <Icon name={icon} size="14" color="#B3BAC5" />
        </span>
        <span className="km__c--side-menu-item-group-title-text">{label}</span>
        <span className="km__c--side-menu-collapse-icon">
          <Icon
            name={isGroupShown() ? "chevron-down" : "chevron-up"}
            size="18"
            color="#5E6C84"
          />
        </span>
      </div>
      {isGroupShown() ? (
        <div className="km__c--side-menu-item-group-list">{children}</div>
      ) : null}
    </div>
  );
}

SideMenuItemGroup.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.object,
  ]),
};
SideMenuItemGroup.defaultProps = {
  isActive: false,
};
